import { Accordion } from 'react-bootstrap'
import { Zoom } from 'react-awesome-reveal'
import '../../styles/Utils/AccordionItem.css'

{/*
<AccordionItem
    key={item.id}
    index={index}
    indexKey={indexKey}
    header={header}
    body={body}
    animated={false}
/>
*/}

function AccordionItem({ indexKey, index, setIndex, header, body, animated }) {

    if (animated) {
        return (

            <Zoom triggerOnce={true} delay={(indexKey) * 50} duration={500}>
                <Accordion.Item eventKey={indexKey} className='accordionItem'>
                    <Accordion.Header className='accordionItemButton' onClick={() => indexKey !== index ? setIndex(indexKey) : setIndex(null)}>
                        {header}
                    </Accordion.Header>
                    <Accordion.Body className='accordionItemBody'>
                        {body}
                    </Accordion.Body>
                </Accordion.Item>
            </Zoom>

        )
    } else {
        return (

            <Accordion.Item eventKey={indexKey} className='accordionItem'>
                <Accordion.Header className='accordionItemButton' onClick={() => indexKey !== index ? setIndex(indexKey) : setIndex(null)}>
                    {header}
                </Accordion.Header>
                <Accordion.Body className='accordionItemBody'>
                    {body}

                </Accordion.Body>
            </Accordion.Item>

        )
    }

}

export default AccordionItem